import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets-lqy194kg.emergentagent.net/job_chip-design-hub-3/artifacts/j3mdu5rx_image.png" 
              alt="Buckeye Silicon Logo" 
              className="h-20 w-20"
            />
            <div>
              <h1 className="text-3xl font-black text-[#BB0000] tracking-tight" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}>Buckeye Silicon</h1>
              <p className="text-sm text-gray-600">Ohio State University</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('mission')} className="text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
              Mission
            </button>
            <button onClick={() => scrollToSection('learning')} className="text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
              What You'll Learn
            </button>
            <button onClick={() => scrollToSection('team')} className="text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
              Leadership
            </button>
            <button onClick={() => scrollToSection('advisors')} className="text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
              Advisor
            </button>
            <Button 
              onClick={() => scrollToSection('contact')} 
              className="bg-[#BB0000] hover:bg-[#990000] text-white transition-colors"
            >
              Get Involved
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('mission')} className="text-left text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
                Mission
              </button>
              <button onClick={() => scrollToSection('learning')} className="text-left text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
                What You'll Learn
              </button>
              <button onClick={() => scrollToSection('team')} className="text-left text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
                Leadership
              </button>
              <button onClick={() => scrollToSection('advisors')} className="text-left text-gray-700 hover:text-[#BB0000] transition-colors font-medium">
                Advisor
              </button>
              <Button 
                onClick={() => scrollToSection('contact')} 
                className="bg-[#BB0000] hover:bg-[#990000] text-white transition-colors w-full"
              >
                Get Involved
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
